import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["value", "disableFormatting", "decimalCount", "displayTrailingZeros", "prefix", "suffix", "noSpaceAfterSuffix", "className", "blankDisplay", "zeroIsBlank", "displayOrdinal", "abbreviate", "thousandSeparator", "typographyVariant", "weightVariant", "color", "noWrap", "useNegForEmptyValue", "enableFlexboxTruncation"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Typography } from "components/mui";
import { formatNumber } from "utils/numberFormatting";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export { convertToOrdinal, abbreviateNumber } from "utils/numberFormatting";

/**
 * Formats and displays numbers with various options.
 *
 * **Tooltip Compatibility**: This component automatically wraps itself in a div when a ref
 * is provided (e.g., by CustomTooltip), ensuring tooltip event handlers work correctly.
 *
 * **Text Truncation**: Use `noWrap` to enable ellipsis truncation with flexbox layout.
 * When `noWrap` or `enableFlexboxTruncation` is set, the wrapper div includes
 * `display: flex, minWidth: 0` for proper truncation behavior.
 *
 * @example
 * // ✅ Tooltip works automatically (ref triggers wrapper div)
 * <CustomTooltip title="Full value">
 *   <NumberFormatter value={123456} />
 * </CustomTooltip>
 *
 * @example
 * // ✅ With text truncation (adds flex styles for ellipsis)
 * <CustomTooltip title="Full value">
 *   <NumberFormatter value={123456} noWrap />
 * </CustomTooltip>
 */

var NumberFormatter = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var value = props.value,
    disableFormatting = props.disableFormatting,
    _props$decimalCount = props.decimalCount,
    decimalCount = _props$decimalCount === void 0 ? 0 : _props$decimalCount,
    displayTrailingZeros = props.displayTrailingZeros,
    prefix = props.prefix,
    suffix = props.suffix,
    _props$noSpaceAfterSu = props.noSpaceAfterSuffix,
    noSpaceAfterSuffix = _props$noSpaceAfterSu === void 0 ? false : _props$noSpaceAfterSu,
    className = props.className,
    _props$blankDisplay = props.blankDisplay,
    blankDisplay = _props$blankDisplay === void 0 ? null : _props$blankDisplay,
    zeroIsBlank = props.zeroIsBlank,
    displayOrdinal = props.displayOrdinal,
    abbreviate = props.abbreviate,
    thousandSeparator = props.thousandSeparator,
    _props$typographyVari = props.typographyVariant,
    typographyVariant = _props$typographyVari === void 0 ? "paragraph_medium" : _props$typographyVari,
    weightVariant = props.weightVariant,
    color = props.color,
    noWrap = props.noWrap,
    _props$useNegForEmpty = props.useNegForEmptyValue,
    useNegForEmptyValue = _props$useNegForEmpty === void 0 ? false : _props$useNegForEmpty,
    _props$enableFlexboxT = props.enableFlexboxTruncation,
    enableFlexboxTruncation = _props$enableFlexboxT === void 0 ? false : _props$enableFlexboxT,
    rest = _objectWithoutProperties(props, _excluded);
  var formattedValue = formatNumber(value, {
    disableFormatting: disableFormatting,
    decimalCount: decimalCount,
    displayTrailingZeros: displayTrailingZeros,
    prefix: typeof prefix === "string" ? prefix : "",
    suffix: typeof suffix === "string" && suffix && !noSpaceAfterSuffix ? " ".concat(suffix) : typeof suffix === "string" ? suffix : "",
    blankDisplay: blankDisplay || "—",
    zeroIsBlank: zeroIsBlank,
    displayOrdinal: displayOrdinal,
    abbreviate: abbreviate,
    thousandSeparator: thousandSeparator,
    useNegForEmptyValue: useNegForEmptyValue
  });
  var hasReactNodePrefix = prefix && typeof prefix !== "string";
  var hasReactNodeSuffix = suffix && typeof suffix !== "string";
  var isBlank = value == null || zeroIsBlank && value === 0 || isNaN(value);
  var content = /*#__PURE__*/_jsxs(Typography, {
    variant: typographyVariant,
    weight: weightVariant,
    className: "number-render ".concat(className || ""),
    color: color,
    noWrap: noWrap,
    children: [hasReactNodePrefix && prefix, hasReactNodePrefix ? formatNumber(value, {
      disableFormatting: disableFormatting,
      decimalCount: decimalCount,
      displayTrailingZeros: displayTrailingZeros,
      blankDisplay: blankDisplay || "—",
      zeroIsBlank: zeroIsBlank,
      displayOrdinal: displayOrdinal,
      abbreviate: abbreviate,
      thousandSeparator: thousandSeparator,
      useNegForEmptyValue: useNegForEmptyValue
    }) : formattedValue, hasReactNodeSuffix && !noSpaceAfterSuffix && !isBlank && " ", hasReactNodeSuffix && suffix]
  });

  // Wrap in div when ref is provided (for tooltip compatibility) or when truncation is needed
  var needsWrapper = ref || enableFlexboxTruncation || noWrap;
  var needsTruncationStyles = enableFlexboxTruncation || noWrap;
  if (needsWrapper) {
    var divStyle = needsTruncationStyles ? {
      display: "flex",
      minWidth: 0
    } : undefined;
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
      ref: ref,
      style: divStyle
    }, rest), {}, {
      children: content
    }));
  }
  return /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({}, rest), {}, {
    children: content
  }));
});
NumberFormatter.displayName = "NumberFormatter";
export default NumberFormatter;